export default {
  userNotificationKeyExists(state) {
    return (notificationKey) => {
      const { currentUser } = state;
      const { notifications } = currentUser;

      return notifications && notifications.indexOf(notificationKey) > -1;
    };
  },
};
